import React, { useEffect, useState } from "react";
import "./BracketDisplay.css";

// Icons

// Components
import PageHeader from "../../components/display/Rows/PageHeader";
import BackRow from "../../components/display/Rows/BackRow";
import BackdropLoader from "../../components/Loaders/BackdropLoader";
import { db } from "../../firebase";

function getRound(currentRound, totalRounds) {
  const roundNames = [
    "First Round",
    "Round of 32",
    "Round of 16",
    "Quarter-final",
    "Semi-Final",
    "Final",
  ];

  // Check if the current round is within the range of the provided rounds
  if (currentRound > totalRounds || currentRound < 1) {
    return "Invalid round";
  }

  // Calculate the maximum number of rounds that can be represented with the available round names
  const maxRounds = roundNames.length;

  // Calculate the number of remaining rounds after the current round
  const remainingRounds = totalRounds - currentRound;

  // Calculate the index of the round name based on the remaining rounds
  const roundIndex = Math.min(maxRounds - remainingRounds, maxRounds - 1);

  // Return the corresponding round name
  return roundNames[roundIndex];
}

function TeamBracketDisplay({ tournamentID = "", goBack = () => {} }) {
  const [loading, setLoading] = useState(true);

  const [bracket, setBracket] = useState([]);

  const [final, setFinal] = useState();

  useEffect(() => {
    loadBracket();
  }, []);

  async function loadBracket() {
    const tournamentDoc = await db
      .collection("tournaments")
      .doc(tournamentID)
      .get();
    const tournament = tournamentDoc.data();
    const { bracket } = tournament;
    if (!bracket || bracket.length === 0) {
      return setLoading(false);
    }

    setFinal(bracket[bracket.length - 1].matches[0]);

    setBracket(bracket);
    setLoading(false);
  }

  return (
    <div className="bracket-display team-bd">
      {loading && <BackdropLoader />}
      <BackRow action={goBack} />
      <PageHeader text="Team Bracket Display" />

      <div className="bd-box">
        <div className="bd-left">
          {bracket.map((round, index) => {
            if (index === bracket.length - 1) {
              return null;
            }
            const matches = round.matches;
            return (
              <div className="bd-round" key={`${index}bdleft`}>
                <div className="bdr-header">
                  <p>{getRound(index + 1, bracket.length + 1)}</p>
                </div>
                {matches.map((match, index2) => {
                  if (index2 >= matches.length / 2) {
                    return null;
                  }
                  const { teams } = match;
                  const t1 = teams[0];
                  const t2 = teams[1];

                  let nameOne = "";
                  let nameTwo = "";

                  nameOne = `${t1.players[0].name} / ${t1.players[1].name}`;
                  nameTwo = `${t2.players[0].name} / ${t2.players[1].name}`;

                  if (t1.players[0].name.includes("Winner Match")) {
                    nameOne = t1.players[0].name;
                  }
                  if (t2.players[0].name.includes("Winner Match")) {
                    nameTwo = t2.players[0].name;
                  }
                  return (
                    <div className="bd-match" key={`${index2}bdlmatch`}>
                      {/* <p className="match-pee">Match {index2 + 1}</p> */}
                      <div className="bdm-box">
                        <div
                          className={
                            match.winnerID === teams[0].teamID
                              ? "bdm-player bdm-active"
                              : "bdm-player"
                          }
                        >
                          <h1>{nameOne}</h1>
                        </div>
                        <div className="bdm-vs">
                          {match.completed && match.rem === 0 ? (
                            <p>{match.by} UP</p>
                          ) : match.completed && match.rem > 0 ? (
                            <p>
                              {match.by} & {match.rem}
                            </p>
                          ) : (
                            <p>vs</p>
                          )}
                        </div>
                        <div
                          className={
                            match.winnerID === teams[1].teamID
                              ? "bdm-player bdm-active"
                              : "bdm-player"
                          }
                        >
                          <h1>{nameTwo}</h1>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
        <div className="bd-final">
          {final && (
            <div className="bd-round">
              <div className="bdr-header">
                <p>FINAL</p>
              </div>
              <div className="bd-final bd-match">
                <div className="bdm-box">
                  <div
                    className={
                      final.winnerID === final.teams[0].teamID
                        ? "bdm-player bdm-active"
                        : "bdm-player"
                    }
                  >
                    <h1>
                      {" "}
                      {final.teams[0].players[0].name} /{" "}
                      {final.teams[0].players[1].name}{" "}
                    </h1>
                  </div>
                  <div className="bdm-vs">
                    {final.completed && final.rem === 0 ? (
                      <p>{final.by} UP</p>
                    ) : final.completed && final.rem > 0 ? (
                      <p>
                        {final.by} & {final.rem}
                      </p>
                    ) : (
                      <p>vs</p>
                    )}
                  </div>
                  <div
                    className={
                      final.winnerID === final.teams[1].teamID
                        ? "bdm-player bdm-active"
                        : "bdm-player"
                    }
                  >
                    <h1>
                      {" "}
                      {final.teams[1].players[0].name} /{" "}
                      {final.teams[1].players[1].name}{" "}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="bd-right">
          {bracket.map((round, index) => {
            if (index === bracket.length - 1) {
              return null;
            }

            const matches = round.matches;
            return (
              <div className="bd-round" key={`${index}bdleft`}>
                <div className="bdr-header">
                  <p>{getRound(index + 1, bracket.length + 1)}</p>
                </div>{" "}
                {matches.map((match, index2) => {
                  if (index2 < matches.length / 2) {
                    return null;
                  }
                  const { teams } = match;
                  const t1 = teams[0];
                  const t2 = teams[1];

                  let nameOne = "";
                  let nameTwo = "";

                  nameOne = `${t1.players[0].name} / ${t1.players[1].name}`;
                  nameTwo = `${t2.players[0].name} / ${t2.players[1].name}`;

                  if (t1.players[0].name.includes("Winner Match")) {
                    nameOne = t1.players[0].name;
                  }
                  if (t2.players[0].name.includes("Winner Match")) {
                    nameTwo = t2.players[0].name;
                  }
                  return (
                    <div className="bd-match" key={`${index2}bdlmatch`}>
                      {/* <p className="match-pee">Match {index2 + 1}</p> */}
                      <div className="bdm-box">
                        <div
                          className={
                            match.winnerID === teams[0].teamID
                              ? "bdm-player bdm-active"
                              : "bdm-player"
                          }
                        >
                          <h1>{nameOne}</h1>
                        </div>
                        <div className="bdm-vs">
                          {match.completed && match.rem === 0 ? (
                            <p>{match.by} UP</p>
                          ) : match.completed && match.rem > 0 ? (
                            <p>
                              {match.by} & {match.rem}
                            </p>
                          ) : (
                            <p>vs</p>
                          )}
                        </div>
                        <div
                          className={
                            match.winnerID === teams[1].teamID
                              ? "bdm-player bdm-active"
                              : "bdm-player"
                          }
                        >
                          <h1>{nameTwo}</h1>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default TeamBracketDisplay;
